import { applySlide, getTile, legalDirections } from '@tessera/engine';
export function enumerateSlides(board) {
    const out = [];
    for (const tile of board.tiles.values()) {
        for (const dir of legalDirections(board, tile.id)) {
            out.push({ from: tile.coord, direction: dir });
        }
    }
    return out;
}
export function applySlideByCoord(board, from, dir) {
    const tile = getTile(board, from);
    if (!tile)
        throw new Error(`applySlideByCoord: no tile at ${from.q},${from.r}`);
    const res = applySlide(board, tile.id, dir);
    // W14 Ballast: if gravity cycled (engine guard tripped), treat the move as
    // invalid for search purposes. Returning movesUsed=0 with the original
    // pre-slide board makes the solver / generator skip this branch — IDA*
    // already discards no-op slides. The generator's downstream rate report
    // can additionally inspect res.cycled if we want to distinguish "level had
    // unsolvable cycles" from "level was just unsolvable"; for now skipping
    // the move is sufficient.
    if (res.cycled) {
        return { board, movesUsed: 0 };
    }
    return { board: res.board, movesUsed: res.movesUsed };
}
